import { useEffect, useRef } from 'react';

import type {
  QuestionNarrationOutcome,
  QuestionNarrationOutcomeHandler,
  QuestionNarrationPresentation,
} from '../narrationEvents';

interface UseCommittedQuestionNarrationOutcomeOptions {
  outcomeKey: string | null;
  outcome: QuestionNarrationOutcome | null;
  presentation: QuestionNarrationPresentation | null;
  onCommitted?: QuestionNarrationOutcomeHandler;
  reset?: boolean;
}

export function useCommittedQuestionNarrationOutcome({
  outcomeKey,
  outcome,
  presentation,
  onCommitted,
  reset = false,
}: UseCommittedQuestionNarrationOutcomeOptions): void {
  const committedOutcomeKeyRef = useRef<string | null>(null);

  useEffect(() => {
    if (reset) {
      committedOutcomeKeyRef.current = null;
      return;
    }
    if (
      outcomeKey === null
      || outcome === null
      || presentation === null
      || committedOutcomeKeyRef.current === outcomeKey
    ) {
      return;
    }
    committedOutcomeKeyRef.current = outcomeKey;
    onCommitted?.(outcome, presentation);
  }, [onCommitted, outcome, outcomeKey, presentation, reset]);
}
